<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="38" viewBox="0 0 30 38">
    <path
      d="M97.641,172.228h-3.75v2.337h2.5V195.6h-25V174.565h2.5v-2.337h-3.75a1.211,1.211,0,0,0-1.25,1.169V196.77a1.211,1.211,0,0,0,1.25,1.169h27.5a1.211,1.211,0,0,0,1.25-1.169V173.4A1.211,1.211,0,0,0,97.641,172.228Z"
      transform="translate(-68.891 -159.939)"
      fill="#707070"
    />
    <path
      d="M167.28,4.7V22.12h2.533V4.7l5.438,5.276,1.791-1.738L168.547,0l-8.5,8.242,1.791,1.738Z"
      transform="translate(-153.547 0)"
      fill="#707070"
    />
  </svg>
</template>
